import { Routes, Route } from 'react-router-dom';
import SchemeList from './pages/schemeList';

function SchemeRoutes() {
  return (
    <Routes>
      <Route path="/" element={<SchemeList />} />
    </Routes>

    
  );
}


export default SchemeRoutes;
